import { Tracker } from "@/models/tracker";

/**
 * Type de retour pour getTrackerValue
 */
export interface TrackerValue {
  key: string;
  value: string;
  source: string;
}

/**
 * Extrait la valeur d'affichage principale d'un tracker
 * Pour les imports: retourne le nom des métadonnées
 * Pour les autres: retourne le premier paramètre (excluant metadata)
 */
export const getTrackerValue = (
  tracker: Tracker | undefined
): TrackerValue | undefined => {
  if (!tracker) return;

  if (tracker.is_import) {
    return {
      source: "import",
      key: "name",
      value: tracker.metadata.name,
    };
  }

  const key =
    Object.keys(tracker.params).length > 0
      ? Object.keys(tracker.params).filter((e) => e !== "metadata")[0]
      : undefined;

  return key
    ? {
        key,
        value: `${tracker.params[key]}`,
        source: tracker.source,
      }
    : undefined;
};

/**
 * Extrait la source depuis le path d'un tracker
 * La source est la première partie du path (ex: /youtube/keywords -> youtube)
 */
export const getSourceFromPath = (tracker: Tracker): string | undefined => {
  if (tracker.is_import) {
    return "import";
  }

  if (!tracker.path) {
    return tracker.source; // Fallback sur tracker.source si path n'existe pas
  }

  // Extraire la première partie du path après le premier /
  const pathParts = tracker.path.split("/").filter(Boolean);
  return pathParts[0] || tracker.source;
};

/**
 * Fonction pour obtenir la source d'un tracker (utilisée pour le groupement)
 * Similaire à getSourceFromPath mais avec une logique légèrement différente pour les trackers sans path
 */
export const getTrackerSource = (tracker: Tracker): string => {
  if (tracker.is_import) return "Import";
  if (!tracker.path) return tracker.source || "Autre";
  const pathParts = tracker.path.split("/").filter(Boolean);
  return pathParts[0] || tracker.source || "Autre";
};

/**
 * Obtient l'URL Simple Icons pour une source
 */
export const getSimpleIconUrl = (sourceName: string): string => {
  const normalizedName = sourceName.toLowerCase().replace(/[^a-z0-9]/g, "");
  const specialCases: Record<string, string> = {
    vkontakte: "vk",
    weibo: "sinaweibo",
    okru: "odnoklassniki",
    press: "newspaper",
    news: "newspaper",
    import: "fileimport",
  };
  const iconName = specialCases[normalizedName] || normalizedName;
  return `https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/${iconName}.svg`;
};












